import { RoutesCountSubscription } from "../../graphql/generated/operations";

/**
 * @param {RoutesCountSubscription | undefined} data
 * @returns {number | undefined}
 */
export const formatter = (data) => data?.routesAggregate.aggregate?.count;
